import { logError } from '@office-start/telemetry-service';
/**
 * @param debugInfo Information to help with debugging the error
 * @param message Descriptor for what's happening
 *
 * @description Used to log error events by type
 */
export var logAppHostError = function (errorType, debugInfo, message) {
    logError({
        eventName: 'MOS_App_Host_Error',
        errorType: errorType,
        message: message,
        debugInfo: debugInfo,
        area: 'MOSAppHost',
    });
};
//# sourceMappingURL=logAppHostError.js.map